import { Observable } from 'rxjs'

import { PmcPage } from '@/api/model/base'

import { RoutingAPIConstant } from '../constant/routing'
import { Bank } from '../model/channel'
import { BaseService } from './base-service'

export class RoutingService extends BaseService {
    protected routingConstant: RoutingAPIConstant
    constructor() {
        super()
        this.routingConstant = new RoutingAPIConstant()
    }

    outComeRouteManageList(data = {}): Observable<PmcPage<any>> {
        return this.requestPmc(this.routingConstant.OutComeRouteManageList(data))
    }

    addOutComeRoute(data = {}): Observable<number> {
        return this.requestPmc(this.routingConstant.AddOutComeRoute(data))
    }

    updateOutComeRoute(data = {}): Observable<number> {
        return this.requestPmc(this.routingConstant.UpdateOutComeRoute(data))
    }

    deDuctManageList(data = {}): Observable<PmcPage<any>> {
        return this.requestPmc(this.routingConstant.DeDuctManageList(data))
    }

    addDeDuct(data = {}): Observable<number> {
        return this.requestPmc(this.routingConstant.AddDeDuct(data))
    }

    updateDeDuct(data = {}): Observable<number> {
        return this.requestPmc(this.routingConstant.UpdateDeDuct(data))
    }

    queryBankListByChannelId(data = {}): Observable<Bank[]> {
        return this.requestPmc(this.routingConstant.QueryBankListByChannelId(data))
    }
}
